import * as React from 'react';
import {useEffect, useRef} from 'react';
import SamsungPayMobileBox from '../../components/common/SamsungPayMobileBox';
import {useTranslation} from 'react-i18next';
import styles from '../../css/SamsungPayMobileBox.module.css';
import classNames from 'classnames/bind';
import {
  MOBILE_ERROR_TYPE,
  TRANSACTION_STATUS,
  POST_MESSAGE_TYPE,
  POST_MESSAGE_CONTENT_MESSAGE,
  PAYMENT_STATUS,
  MOBILE_INSTALL_TYPE_TO_MESSAGE,
  MOBILE_INSTALL_TYPE_BUTTON,
  MOBILE_INSTALL_TYPE
} from '../../common/constants';
import {updateTransactionStatus} from '../../libs/GsmpiApi';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {postMessageToOpener} from '../../utils/postMessage';
import i18n from '../../i18n/i18n';
import debug from 'debug';

const cx = classNames.bind(styles);
const log = debug('app:MobileInstallPage');

export default function MobileInstallPage() {
  const {t} = useTranslation();
  const location = useLocation();
  const installType = location.state?.installType || MOBILE_INSTALL_TYPE.INSTALL_APP;
  const isCloseButtonClicked = useRef(false);
  const {transactionId, sourceOrigin} = useSelector((state) => state.paymentClient);
  const navigate = useNavigate();

  useEffect(() => {
    const handleDiscontinuedTransaction = (e) => {
      //this will trigger once the page is about to be unloaded
      if (!e.persisted && !isCloseButtonClicked.current) {
        postMessageToOpener({
          type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
          content: {
            status: PAYMENT_STATUS.FAIL,
            message: POST_MESSAGE_CONTENT_MESSAGE.USER_CANCEL
          },
          sourceOrigin: sourceOrigin
        });
      }
    };

    window.addEventListener('pagehide', handleDiscontinuedTransaction);

    return () => {
      window.removeEventListener('pagehide', handleDiscontinuedTransaction);
    };
  }, [sourceOrigin]);

  const handleUpdateAppClick = () => {
    top.location.href = "samsungapps://ProductDetail/com.samsung.android.spay";
  };

  const handleCloseButtonClick = () => {
    isCloseButtonClicked.current = true;

    const timeOutPayload = {
      payment: {
        status: TRANSACTION_STATUS.CANCELED,
        reason: 'cancelledByUser'
      },
      timestamp: new Date().getTime()
    };

    updateTransactionStatus(transactionId, timeOutPayload)
      .then(() => {
        self.close();
      })
      .catch(() => {
        log('failed to update transaction status');
        navigate(`/gsmpi-web/mobile/${i18n.language}/error`, {state: {errorType: MOBILE_ERROR_TYPE.OTHER_ERRORS}});
      });
  };

  return (
    <SamsungPayMobileBox mobilePageType="main" closeButtonFunction={handleCloseButtonClick}>
      <div id="install">
        <p className={cx('install-txt')}>{t(MOBILE_INSTALL_TYPE_TO_MESSAGE[installType]).replace('%s', 'Samsung Wallet')}</p>
        <div className={cx('btn-block')}>
          <button type="button" className={cx('btn')} onClick={handleUpdateAppClick}>
            {t(MOBILE_INSTALL_TYPE_BUTTON[installType])}
          </button>
        </div>
      </div>
    </SamsungPayMobileBox>
  );
}